window.WishlistMeta = {
  storageKey: "wishlist-product-meta",

  read() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || "{}");
    } catch (error) {
      console.error("[WishlistMeta] read error:", error);
      return {};
    }
  },

  write(meta) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(meta));
    } catch (error) {
      console.error("[WishlistMeta] write error:", error);
    }
  },

  save(product) {
    const id = Number(product?.id);
    const variantId = Number(product?.variantId);

    if (!id || Number.isNaN(id) || !variantId || Number.isNaN(variantId)) {
      return;
    }

    const meta = this.read();

    meta[`${id}_${variantId}`] = {
      id,
      variantId,
      handle: product.handle || "",
      url: product.url || "",
    };

    this.write(meta);
  },

  get(productId, variantId) {
    const meta = this.read();
    return meta[`${productId}_${variantId}`] || null;
  },
};